import {Component, computed, inject, model, ModelSignal} from '@angular/core';
import {IAction} from 'frontier/browserkit';
import AppControlGuids from '../../../../api/ControlGuids';
import {
  JSON_EXPORT_ACTION,
  JSON_IMPORT_ACTION
} from "frontier/browserkit/src/lib/components/control/table-control/default-form-actions.constant";
import {
  CustomDynamicFormComponent
} from 'frontier/browserkit/src/lib/components/control/form-control/dynamic-form/custom-dynamic-form/custom-dynamic-form.component';
import {
  FormElementComponent
} from 'frontier/browserkit/src/lib/components/control/form-control/dynamic-form/form-element/form-element.component';
import {MatDivider} from '@angular/material/divider';
import {
  DynamicFormActionComponent
} from 'frontier/browserkit/src/lib/components/control/form-control/dynamic-form/dynamic-form-action/dynamic-form-action.component';
import {HelpIconComponent} from 'frontier/browserkit/src/lib/components/help-icon/help-icon.component';
import {UiHelperService} from 'frontier/browserkit/src/lib/components/ui-helper/ui-helper.service';
import {GeneralSettingsHelpComponent} from './general-settings-help/general-settings-help.component';
import {CsvHeadersHelpComponent} from './csv-headers-help/csv-headers-help.component';
import {DebitorHelpComponent} from './debitor-help/debitor-help.component';

enum EFormKeys {
  importMode = 'topenitemimport;0',
  invoiceNumber = 'topenitemimport;1',
  balance = 'topenitemimport;2',
  debit = 'topenitemimport;3',
  credit = 'topenitemimport;4',
  debitCreditIdentifier = 'topenitemimport;5',
  date = 'topenitemimport;6',
  debitor = 'topenitemimport;7',
  debitorFilter = 'topenitemimport;8',
  format = 'topenitemimport;9',
  quoteChar = 'topenitemimport;10',
  delimiter = 'topenitemimport;11',
}

@Component({
  selector: 'app-open-item-import-config-form',
  templateUrl: './open-item-import-config-form.component.html',
  styleUrl: './open-item-import-config-form.component.scss',
  standalone: true,
  imports: [FormElementComponent, MatDivider, DynamicFormActionComponent, HelpIconComponent],
})
export class OpenItemImportConfigFormComponent extends CustomDynamicFormComponent {
  private _uiHelperService = inject(UiHelperService);
  override GUID: string = AppControlGuids.TOpenItemImportConfig;
  override actions: ModelSignal<IAction[]> = model<IAction[]>([
    JSON_EXPORT_ACTION,
    JSON_IMPORT_ACTION,
  ]);
  protected EFormKeys = EFormKeys;

  formData = {
    importMode: computed(() => this.getFormElementByKey(EFormKeys.importMode)),
    invoiceNumber: computed(() => this.getFormElementByKey(EFormKeys.invoiceNumber)),
    balance: computed(() => this.getFormElementByKey(EFormKeys.balance)),
    debit: computed(() => this.getFormElementByKey(EFormKeys.debit)),
    credit: computed(() => this.getFormElementByKey(EFormKeys.credit)),
    debitCreditIdentifier: computed(() => this.getFormElementByKey(EFormKeys.debitCreditIdentifier)),
    date: computed(() => this.getFormElementByKey(EFormKeys.date)),
    debitor: computed(() => this.getFormElementByKey(EFormKeys.debitor)),
    debitorFilter: computed(() => this.getFormElementByKey(EFormKeys.debitorFilter)),
    format: computed(() => this.getFormElementByKey(EFormKeys.format)),
    quoteChar: computed(() => this.getFormElementByKey(EFormKeys.quoteChar)),
    delimiter: computed(() => this.getFormElementByKey(EFormKeys.delimiter)),
  };

  showHelpForGeneralSettings() {
    this._uiHelperService.openHelp({component: GeneralSettingsHelpComponent})
  }

  showHelpForCsvHeaders() {
    this._uiHelperService.openHelp({component: CsvHeadersHelpComponent})
  }

  showHelpForDebitor() {
    this._uiHelperService.openHelp({component: DebitorHelpComponent})
  }
}
